import * as React from 'react';

function SvgActAddcl(props) {
    return (
        <svg
            viewBox="0 0 128 128"
            {...props}
        >
            <path
                d="M60 85.73a3.1 3.1 0 01-3.1 3.1H19.66a3.1 3.1 0 01-3.11-3.1A18.63 18.63 0 0135.18 67.1h6.21A18.63 18.63 0 0160 85.73zM38.28 39.17A12.42 12.42 0 1050.7 51.58a12.41 12.41 0 00-12.42-12.41zm27.98 46.96a8 8 0 01-.49 2.7h14a2.71 2.71 0 002.71-2.7v-1.2a15.1 15.1 0 00-15.03-15.06h-2.39a15 15 0 00-5.17.95 21.52 21.52 0 016.37 15.3zm0-40.63a10.83 10.83 0 1010.83 10.83A10.83 10.83 0 0066.25 45.5zM111.45 63h-8v-8a3 3 0 10-6 0v8h-8a3 3 0 100 6h8v8a3 3 0 006 0v-8h8a3 3 0 100-6z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SvgActAddcl;
